import { useTranslation } from "react-i18next";
import { Label } from "@tellescope/design-system";
import { Textarea } from "@tellescope/ui";
import type { HtmlBlock } from "../../../../../shared/schema";
import { LayoutSection } from "../shared/LayoutSection";
import { VisibilitySection } from "../shared/VisibilitySection";
import type { BlockTypeEditorProps } from "../types";

type HtmlBlockEditorProps = BlockTypeEditorProps<HtmlBlock>;

export function HtmlBlockEditor({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
}: HtmlBlockEditorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>{t("HTML Content")}</Label>
        <Textarea
          value={block.props.content}
          onChange={(e) => updateProps({ content: e.target.value })}
          placeholder={t("<p>Enter HTML content...</p>")}
          rows={8}
          className="font-mono text-sm"
        />
      </div>
      <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
      <VisibilitySection
        visibility={block.visibility}
        onChange={updateVisibility}
        open={visibilityOpen}
        onOpenChange={setVisibilityOpen}
      />
    </div>
  );
}
